// Scroll Counters

(($) => {
  Formstone.Ready(() => {

    let $counters = $('.js-counter');

    function observeCounters(entries) {
      entries.forEach((entry) => {
        let $el = $(entry.target);
        let edge = window.innerHeight - 200;

        if (entry.isIntersecting || entry.boundingClientRect.top < edge) {
          if (!$el.hasClass('js-count_started')) {
            $el.addClass('js-count_started');

            let count = $el.data('count');

            let $animation = $({ countNum: 0 }).animate({ countNum: count }, {
              duration: 1000, // (count > 20 ? 1500 : 1000),
              easing: 'linear',
              step: function() {
                let num = ($el.data('decimal') === true) ? this.countNum.toFixed(1) : Math.ceil(this.countNum);

                $el.text(num);
              },
              complete: function() {
                $el.text(count);
              }
            });

            $el.data('animation', $animation);
          }
        } else {
          if ($el.hasClass('js-count_started')) {
            let $animation = $el.data('animation');

            if ($animation) {
              $animation.stop();
            }

            $el.removeClass('js-count_started').text('0');
          }
        }
      });
    }

    var observer = new IntersectionObserver(observeCounters, {
      root: null,
      rootMargin: '0px 0px 200px 0px',
      threshold: 0.25
    });

    $counters.each((i, counter) => {
      observer.observe(counter);

      $(counter).text('0');
    });

  });
})(jQuery);